export default [
  {
    path: '/company',
    name: 'index',
    component: () => import('@/layout/Empty'),
    meta: {
      personVerify: true
    },
    children: [
      {
        path: 'update-name',
        name: 'updateCompanyName',
        component: () => import('@/views/admin/company/UpdateCompanyName'),
        meta: { title: '更改企业名称' }
      },
      {
        path: 'update-name-success',
        name: 'updateCompanyNameSuccess',
        component: () => import('@/views/admin/company/UpdateCompanyNameSuccess'),
        meta: { title: '更改企业名称' }
      },
      {
        path: 'change-version',
        name: 'changeVersion',
        component: () => import('@/views/admin/company/changeVersion/changeVersion'),
        meta: {
          title: '版本升级',
          layout: {
            name: 'upgrade',
            pageWrap: false
          }
        }
      },
      {
        path: 'change-version-success',
        name: 'changeVersionSuccess',
        component: () => import('@/views/admin/company/changeVersion/changeVersionSuccess'),
        meta: {
          title: '版本升级成功',
          layout: {
            name: 'upgrade',
            pageWrap: false
          }
        }
      }
    ]
  },
  {
    path: '/company/detail',
    name: 'companyDetail',
    component: () => import('@/views/admin/company/CompanyDetail'),
    meta: { title: '企业主页' }
  },
  {
    path: '/company/ca',
    name: 'ca',
    component: () => import('@/views/admin/company/Ca'),
    meta: { title: 'CA证书' }
  },
  //处理原路由兼容性问题 start
  {
    path: '/account/home/enterprise',
    redirect: '/company/list'
  },
  {
    path: '/account/home/basicData',
    redirect: '/information'
  }
  //处理原路由兼容性问题 end
]
